export const gridHeight = 1080 / 24;
export const gridWidth = 1920 / 24;
